<template>
    <section>
        <b-card no-body class="card-employee-task e_font_family">
            <b-card-header :class="`${isDark ? 'bg-primary' : 'bg-info text-white'}`">
                <div class="d-flex justify-content-center align-items-center">
                    <div>
                        <b-avatar class="me-10 blinking" size="28" src="@/assets/images/football/FB.gif" />
                    </div>
                    <div>
                        <b-card-title :class="`${isDark ? 'text-white' : 'text-white'}`">{{ matchData.matchName
                            }}</b-card-title>
                        <small>{{ matchData.matchTime.substring(11) }}</small>
                    </div>
                </div>

                <div class="d-flex justify-content-center align-items-center" v-if="matchData.keynote!=0">
                    <div>
                        <b-avatar class="me-10 blinking" size="22">
                            <feather-icon icon="HeartIcon" class="blinking text-danger" />
                        </b-avatar>
                    </div>
                    <div>
                        <span > {{matchData.keynoteStr}}</span>
                    </div>
                </div>


                <div class="justify-content-between " style="cursor:pointer;"
                    :class="`${isDark ? 'text-white' : 'text-white'}`">
                    <span :id="'popover-target-zs_' + matchData.matchId" variant="outline-primary">
                        <feather-icon icon="TrendingUpIcon" size="15" />
                        指数
                    </span>
                    <span class="ms-10">|</span>
                    <span class="ms-10 me-10" :id="'popover-target-js_' + matchData.matchId" variant="outline-primary">
                        <link>
                        <feather-icon icon="VideoIcon" size="15" />
                        技术
                        </link>
                    </span>
                </div>
            </b-card-header>
            <!-- body -->
            <b-card-body>
                <div class="employee-task d-flex justify-content-between align-items-center  ">
                    <div class="col-4 col-lg-4 col-xl-4 col-md-4 col-sm-4 m-0 p-0 text-right"
                        style="text-align: right;">
                        <div class="d-flex align-items-center justify-content-center m-0 p-0">
                            <div class="mr-20  ">
                                <!-- <h6>{{ matchData.teams1 }}</h6> -->
                                <h6 class="">{{ matchData.teams1.length > 6 ? matchData.teams1.substr(0,
                                    6) + '...' : matchData.teams1 }}</h6>
                                <!-- <small><b-badge class="profile-badge" variant="light-danger">
                                        主队
                                    </b-badge></small> -->
                            </div>
                            <b-avatar class="ms-10" rounded size="42"
                                :src="`http://lcsjfx.com/football/${matchData.homeImg}`" />

                        </div>
                    </div>
                    <div class="col-4 col-xl-4 col-md-4 col-sm-4  text-center m-0 p-0">
                        <span class="fs-lg-15" v-b-tooltip.hover.v-success.right="'当前比赛时间'"><feather-icon
                                icon="WatchIcon" size="10" />
                            {{ matchData.nowstatus }}
                            <span class="text-success blinking">′</span>
                        </span>

                        <div class="fs-lg-20 mt-10"><b-badge class="profile-badge" variant="light-danger">
                                {{ matchData.nowscore.split('-')[0] }}
                            </b-badge> -
                            <b-badge class="profile-badge" variant="light-info">
                                {{ matchData.nowscore.split('-')[1] }}
                            </b-badge>
                        </div>

                        <div class="p-1 fs-lg-18 mt-10">
                            <span class="badge bg-primary fs-15" v-b-tooltip.hover.v-danger.right="'推荐'"
                                v-if="matchData.betType.includes('大') || matchData.betType.includes('主') || matchData.betType == '胜'">{{
                                    matchData.betType }}</span>
                            <span class="badge bg-info fs-15" v-b-tooltip.hover.v-danger.right="'推荐'"
                                v-if="matchData.betType.includes('小') || matchData.betType.includes('客') || matchData.betType.includes('负')">{{
                                    matchData.betType }}</span>
                            <span class="badge bg-dark fs-15" v-b-tooltip.hover.v-danger.right="'推荐'"
                                v-if="matchData.betType.includes('平')">{{
                                    matchData.betType }}</span>
                        </div>
                    </div>
                    <div class="col-4 col-lg-4 col-xl-4 col-md-4 col-sm-4 m-0 p-0">
                        <div class="d-flex align-items-center">
                            <b-avatar style="margin-right: 10px;" rounded size="42"
                                :src="`http://lcsjfx.com/football/${matchData.guestImg}`" />
                            <div class="mr-20 ">
                                <!-- <h6>{{ matchData.teams2 }}</h6> -->
                                <h6 class="">{{ matchData.teams2.length > 6 ? matchData.teams2.substr(0,
                                    6) + '...' : matchData.teams2 }}</h6>
                                <!-- <small><b-badge class="profile-badge" variant="light-info">
                                        客队
                                    </b-badge></small> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center text-center">
                    <b-media no-body v-b-tooltip.hover.top="'提示时盘口'">
                        <b-media-aside class="mr-2">
                            <b-avatar size="40" variant="light-danger">
                                <feather-icon size="24" icon="ActivityIcon" />
                            </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                            <h6 class=" mb-0">
                                盘口
                            </h6>
                            <b-card-text class="font-small-3 mb-0">
                                {{ matchData.handicap }}
                            </b-card-text>
                        </b-media-body>
                    </b-media>

                    <b-media no-body v-b-tooltip.hover.v-info.top="'提示时比分'">
                        <b-media-aside class="mr-2">
                            <b-avatar size="40" variant="light-info">
                                <feather-icon size="24" icon="ClipboardIcon" />
                            </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                            <h6 class=" mb-0">
                                比分
                            </h6>
                            <b-card-text class="font-small-3 mb-0">
                                {{ matchData.score }}
                            </b-card-text>
                        </b-media-body>
                    </b-media>

                    <b-media no-body v-b-tooltip.hover.v-success.top="'提示时比赛时间'">
                        <b-media-aside class="mr-2">
                            <b-avatar size="40" variant="light-success">
                                <feather-icon size="24" icon="AlertCircleIcon" />
                            </b-avatar>
                        </b-media-aside>
                        <b-media-body class="my-auto">
                            <h6 class=" mb-0">
                                时间
                            </h6>
                            <b-card-text class="font-small-3 mb-0">
                                {{ matchData.status }}′
                            </b-card-text>
                        </b-media-body>
                    </b-media>

                    <!-- <div>
                        <h6 class="text-danger  "> 提示盘口 </h6>
                        <h6 class="mb-0 text-danger text-lighten-1"> {{ matchData.handicap }} </h6>
                    </div> -->
                    <!-- <div>
                        <h6 class="text-warning "> 提示比分 </h6>
                        <h6 class="mb-0 text-warning text-lighten-1"> {{ matchData.score }} </h6>
                    </div>
                    <div>
                        <h6 class="text-secondary"> 提示时间 </h6>
                        <h6 class="mb-0 text-secondary text-lighten-1"> {{ matchData.status }}′ </h6>
                    </div> -->
                </div>
            </b-card-body>
        </b-card>

        <zs :id="matchData.matchId" :matchModel="matchData.matchModel"></zs>
        <Js :matchData="matchData"></Js>

    </section>
</template>


<script>
import { VBPopover } from 'bootstrap-vue'

import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'


import zs from './Zs.vue'
import Js from './Jstj.vue'

export default ({
    components: {
        zs,
        Js
    },
    props: {
        matchData: {
            type: Object,
            default: () => ({})
        }
    },

    directives: {
        'b-popover': VBPopover,
        Ripple,
    },

    data() {
        return {
            dataload: false
        }
    },


    methods: {

    },

    setup() {
        const { skin } = useAppConfig()

        const isDark = computed(() => skin.value === 'dark')

        return { skin, isDark }
    },

});
</script>

<style lang="css" scoped>
/* 定义一个闪烁动画 */
@keyframes blink {

    /* 从0%开始到100%，‌通过opacity属性在1（‌完全不透明）‌和0（‌完全透明）‌之间交替 */
    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }
}

/* 应用闪烁动画到一个类 */
.blinking {
    /* 使用无限次重复闪烁动画 */
    animation: blink 1s infinite;
}


[dir] .card-body {
    margin-top: 0.5rem;
    padding: 1rem;
}

[dir] .card .card-header {
    border-bottom: none;
    padding: 0.3rem;
}


.popover {
    max-width: 1500px;
}

.e_font_family {
    font-family: PingFangSC-Regular, Microsoft YaHei, Heiti, Arial, Helvetica, "sans-serif" !important;
}
</style>